export default "__VITE_ASSET__B6qVpiH3__"